import styled from "@mui/material/styles/styled";

import useNudge from "@app/analytics/MeetingReport/hooks/useNudge";
import useSessionMetadata from "@app/analytics/MeetingReport/hooks/useSessionMetadata";
import MeetingReportSearchBox from "@app/analytics/MeetingReport/MeetingReportSearchBox";
import { useMeetingReportContext } from "@app/analytics/MeetingReport/providers/MeetingReportContext";
import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";
import Transcript from "@app/analytics/MeetingReport/Transcript";
import EmptyTranscript from "@app/analytics/MeetingReport/Transcript/EmptyTranscript";
import useFeatureAccess from "@app/common/hooks/useFeatureAccess";

import Nudge from "@rui/Nudge";
import Stack from "@rui/Stack";

import useSearch from "../hooks/useSearch";

const Container = styled(Stack)(({ theme }) => ({
  backgroundColor: "#FFF",
  borderRadius: "8px",
  paddingBottom: theme.spacing(2),
  "& .speech-bubble__annotations, .transcript-turn__annotations": {
    display: "none",
  },
  "& .speech-bubble, .transcript-turn__speech-bubble": {
    scrollMarginTop: "40px",
  },
}));

const SidebarTranscript = () => {
  const {
    data: { isRestrictedReport },
  } = useSessionMetadata();
  const { canAccessTranscript } = useFeatureAccess();
  const { sidebarScrollContainer } = useMeetingReportContext();
  const search = useSearch();

  const [nudge, setNudge] = useNudge("sidebar");

  const { playbackParagraphId, setActiveItem, available } = useTranscriptStore(
    (state) => ({
      playbackParagraphId: state.playbackParagraphId,
      setActiveItem: state.setActiveItem,
      available: state.transcriptAvailable,
    })
  );

  if (isRestrictedReport) return null;

  if (!available) {
    return (
      <EmptyTranscript
        type={canAccessTranscript ? "default" : "unauthorized"}
      />
    );
  }

  const handleNudgeClick = () => {
    if (!playbackParagraphId) return;
    setActiveItem({ id: playbackParagraphId, type: "paragraph" });
    setNudge(null);
  };

  return (
    <>
      <Container flexGrow={1}>
        <MeetingReportSearchBox
          onClose={search.clearSearch}
          open={Boolean(search.term)}
          readOnly
          sx={{ position: "sticky", top: 0, px: 2, pb: 1 }}
        />
        <Transcript
          context={{ section: "sidebar", tab: "coaching" }}
          scrollContainer={sidebarScrollContainer}
        />
      </Container>
      {nudge != null && (
        <Nudge containerSx={{ top: 8 }} {...nudge} onClick={handleNudgeClick} />
      )}
    </>
  );
};

export default SidebarTranscript;
